var scope_0 = require('/home/runner/work/skalar-website/skalar-website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/16bd6de5d503d4d8c83cac001ffabc04.js').default;
var scope_1 = require('/home/runner/work/skalar-website/skalar-website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/62bd1898e5ab8e92b930ecc6270fd069.js').default;
var scope_2 = require('/home/runner/work/skalar-website/skalar-website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/7ec27163520ab279370fdda3caed3de4.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    